/*!

=========================================================
* Paper Kit React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  TabContent,
  TabPane,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import axios from 'axios';
function LandingPage() {
  const [activeTab, setActiveTab] = React.useState("1");
  const [name,setName]=React.useState("");
  const [email,setEmail]=React.useState("");
  const [phone,setPhone]=React.useState("");
  const [message,setMessage]=React.useState("");
  const [formError,setFormError]=React.useState(false);
  const [showProgressBar,setShowProgressBar]=React.useState(false);
  const [showSubmitFormButton,setShowSubmitFormButton]=React.useState(true);
  const [formTextValue,setFormTextValue]=React.useState("");
  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });



  const getName = (e) =>{
    let username = e.target.value; 
    setName(username)
    console.log(name);
  }
  
  
  const getEmail = (e) =>{
    let userEmail = e.target.value; 
    //the most important thing is that we use a RegEx
    //in order to manage the input of the email
    //at least we can get a some what valid email
    if(userEmail.match(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)){
      setEmail(userEmail)
      }else{
        setEmail("")
      console.log("Incorrect Email, must match Expression");
    }
  
    console.log(email);
  }

  const getPhone = (e) =>{
    let phoneNumber = e.target.value; 
    setPhone(phoneNumber)
    console.log(phone);
  }
  

  
  const getDescription = (e) =>{
    let userMessage = e.target.value; 
    setMessage(userMessage)
    console.log(message);
  }

  const submitForm = (e) =>{
    e.preventDefault();

    if(name === "" || email === "" || phone === "" ){
    setFormError(true)
       return false;
    }else{
        setFormError(false)

         const data ={
           name: name,
           email: email,
           phone: phone,
           message: message
         };

        
         
         setShowProgressBar(true);
         setShowProgressBar(false);
          const url= 'http://185.81.166.162:8081/facilities/putlandingpagecompany/'+name+'/'+email+'/'+phone+'/'+message+'/ADMIN';

         axios.put(url,{
          headers: {
            "Access-Control-Allow-Origin": "*"
          }})
         .then(response =>{
           console.log(response);
           console.log(response.resultCode);
           setFormTextValue('Kaydınız Başarıyla Alındı');
           setShowProgressBar(false);         
         });

         console.log('test');
        console.log(`UserData: {
            Username: ${name},
            Email: ${email},
            Phone: ${phone}
        }`)
    
    
        console.log("form sent")
    
    }
 
  }


  return (
    <>
      <ExamplesNavbar />
      <LandingPageHeader />
      <div className="main">
        <div className="section text-center">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h2 className="title">Tesisinizi Büyütün</h2>
                <h5 className="description">
                  Flex Play spor alanında bir pazar yeri oluşturmayı hedefler.
                  Tesisinizi sporcular arasında öne çıkarın ve müşterileinize 
                  daha hızlı, etkili ve kolay bir biçimde ulaşın. Data analizi
                  müşteri davranışlarını öğrenebilir ve buna yönelik adımlar
                  atarak tesisinizi geliştirebilirsiniz.
                </h5>
                <br />
           
              </Col>
            </Row>
            <br />
            <br />
            <Row>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-globe" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Kazanım</h4>
                    <p className="description">
                      Tesisinizin görünürlüğünü artırır. Müşterilere
                      ulaşmanızı sağlar. 
                      Rezerve edilmiş kortların iptal oranlarını düşürür.
                    </p>
                    
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-button-play" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Rezervasyon</h4>
                    <p>
                      Müşterilerinizin rezervasyonlarınızı mobil uygulamalarımız
                      üzerinden yapmalarını sağlayarak hem müşteri memnuniyeti
                      sağlar hem de tesisinizdeki iş gücü maliyetini en aza indirir.
                    </p>
                   
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-chart-bar-32" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Veri Analizi</h4>
                    <p>
                      Müşterilerinizin verilerini yapay zeka algoritmaları ile 
                      inceleyerek kortun doluluğunu optimize etmeyi sağlayın.
                    </p>
                   
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-circle-10" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Bağlılık</h4>
                    <p>
                      Müşterilerinize en iyi spor deneyimi yaşamalarını sağlayın.
                      Oyuncuların hayatlarını kolaylaştırarak ve motivasyonlarını
                      sağlayarak tesisinize bağlılığını artırın.
                    </p>
                    
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
       {/*  <div className="section section-dark text-center">
          <Container>
            <h2 className="title">Tesisler Ne Düşünüyor?</h2>
            <Row>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/faces/clem-onojeghuo-3.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4">Henry Ford</CardTitle>
                        <h6 className="card-category">Product Manager</h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                      Teamwork is so important that it is virtually impossible
                      for you to reach the heights of your capabilities or make
                      the money that you want without becoming very good at it.
                    </p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      className="btn-just-icon btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-twitter" />
                    </Button>
                    <Button
                      className="btn-just-icon btn-neutral ml-1"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-google-plus" />
                    </Button>
                    <Button
                      className="btn-just-icon btn-neutral ml-1"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/faces/joe-gardner-2.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4">Sophie West</CardTitle>
                        <h6 className="card-category">Designer</h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                      A group becomes a team when each member is sure enough of
                      himself and his contribution to praise the skill of the
                      others. No one can whistle a symphony. It takes an
                      orchestra to play it.
                    </p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      className="btn-just-icon btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-twitter" />
                    </Button>
                    <Button
                      className="btn-just-icon btn-neutral ml-1"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-google-plus" />
                    </Button>
                    <Button
                      className="btn-just-icon btn-neutral ml-1"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/faces/erik-lucatero-2.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4">Robert Orben</CardTitle>
                        <h6 className="card-category">Developer</h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                      The strength of the team is each individual member. The
                      strength of each member is the team. If you can laugh
                      together, you can work together, silence isn’t golden,
                      it’s deadly.
                    </p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      className="btn-just-icon btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-twitter" />
                    </Button>
                    <Button
                      className="btn-just-icon btn-neutral ml-1"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-google-plus" />
                    </Button>
                    <Button
                      className="btn-just-icon btn-neutral ml-1"
                      color="link"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </Container>
        </div> */}
      {/*   <div className="title">
                <h3>Navigation Tabs</h3>
              </div>
              <div className="nav-tabs-navigation">
                <div className="nav-tabs-wrapper">
                  <Nav id="tabs" role="tablist" tabs>
                    <NavItem>
                      <NavLink
                        className={activeTab === "1" ? "active" : ""}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        Home
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "2" ? "active" : ""}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        Profile
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={activeTab === "3" ? "active" : ""}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        Messages
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab} className="text-center">
                <TabPane tabId="1">
                  <p>
                    Larger, yet dramatically thinner. More powerful, but
                    remarkably power efficient. With a smooth metal surface that
                    seamlessly meets the new Retina HD display.
                  </p>
                </TabPane>
                <TabPane tabId="2">
                  <p>Here is your profile.</p>
                </TabPane>
                <TabPane tabId="3">
                  <p>Here are your messages.</p>
                </TabPane>
              </TabContent> */}
        <div className="section landing-section">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h2 className="text-center">Bizimle iletişime geçin.</h2>
                <Form className="contact-form">
                  <Row>
                    <Col md="6">
                      <label>Tesisinizin Adı</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-single-02" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Tesis" type="text"  onChange={getName}/>
                      </InputGroup>
                    </Col>
                  
                  </Row>
                  <Row>
                  <Col md="6">
                      <label>E-Posta</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-email-85" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="E-Posta" type="text"  onChange={getEmail}/>
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row>
                  <Col md="6">
                      <label>Telefon</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="nc-icon nc-mobile" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Telefon Numaranız" type="text"  onChange={getPhone}/>
                      </InputGroup>
                    </Col>
                  </Row>
                  <label>Mesaj</label>
                  <Input
                    placeholder="Soru ve görüşleriniz..."
                    type="textarea"
                    rows="4"
                    onChange={getDescription}
                  />
                  <Row>
                    <Col className="ml-auto mr-auto" md="4">
                      <Button className="btn-fill" color="danger" size="lg" onClick={submitForm}>
                        Gönder
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <DemoFooter />
    </>
  );
}

export default LandingPage;
